module.exports = __webpack_public_path__ + "bbb144fd189aaaffb910b20e11dff52c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_25.jpg
// module id = 1704
// module chunks = 5